import { Navigate, useLocation } from 'react-router-dom';
import { detectLocale } from './detectLocale';
import { withLocale } from './paths';

/** Redirect legacy public paths (/login, /register, ...) to /:locale/... */
function LegacyPublicRedirect({ toPath }) {
  const location = useLocation();
  const locale = detectLocale();
  return (
    <Navigate
      to={`${withLocale(locale, toPath)}${location.search}${location.hash}`}
      replace
    />
  );
}

export default LegacyPublicRedirect;
